import { order } from "./statisticsConstants";
import { useGetDialogsQuery } from "../../dialogs/dialogsSlice";

const DonutChart = () => {
  const { data } = useGetDialogsQuery();

  const stats = data?.reduce(
    (acc, item) => {
      acc.total += 1;
      acc.counts[item.status] = (acc.counts[item.status] || 0) + 1;
      return acc;
    },
    { total: 0, counts: {} }
  );

  const chartData = !!stats
    ? Object.entries(stats.counts)
        .map(([status, count]) => ({
          label: status,
          value: count,
        }))
        ?.sort((a, b) => order.indexOf(a.label) - order.indexOf(b.label))
    : [];

  const total = stats?.total || chartData?.length;
  const radius = 45;
  const strokeWidth = 20;
  const circumference = 2 * Math.PI * radius;
  let offset = circumference * 0.75;

  const colors = {
    READY: "#F4C150",
    FINISHED: "#82AABE",
  };

  return (
    <div style={{ width: "120px", height: "120px", position: "relative" }}>
      <svg width="120" height="120">
        <circle
          r={radius}
          cx="60"
          cy="60"
          fill="transparent"
          stroke="#eee"
          strokeWidth={strokeWidth}
        />
        {chartData.map((slice, i) => {
          const dash = (slice.value / total) * circumference;
          const circle = (
            <circle
              key={i}
              r={radius}
              cx="60"
              cy="60"
              fill="transparent"
              stroke={colors[slice.label] || "#eee"}
              strokeWidth={strokeWidth}
              strokeDasharray={`${dash} ${circumference - dash}`}
              strokeDashoffset={-offset}
              strokeLinecap="butt"
              style={{ transition: "stroke-dasharray 0.3s ease" }}
            />
          );
          offset += dash;
          return circle;
        })}
      </svg>
      <h3
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        {total}
      </h3>
    </div>
  );
};

export default DonutChart;
